import { defineStore } from 'pinia'
import { User } from '@auth0/auth0-vue'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    isLoggedIn: false as boolean,
    user: null as User | null,
  }),
  actions: {
    logIn(userAuth: User) {
      this.isLoggedIn = true
      this.user = userAuth
    },
    logOut() {
      this.isLoggedIn = false
      this.user = null
    },
  },
  persist: true,
})
